<template>
  <w-card class="z-dashboard-item white--bg">
    <w-flex>
        
      <w-icon size="45" class="align-self-center xs-hide" :class="iconColor" v-if="useIcon">{{ icon }}</w-icon>
      <w-image :src="image" :width="width" :height="height" class="align-self-center xs-hide zdiimage" v-else-if="!useSlot">
        <span class="zditext title1 text-bold">{{ text }}</span>
      </w-image>
      <slot name="zdileftbox" v-else />
      
      <div class="box ml1"> 
          <slot name="header">
            <p class="" v-html="header"></p>
          </slot>
          <slot name="title">
            <h5 class="mb-0 mt3 title5" v-html="title"> </h5> 
          </slot>
          <slot name="subtitle">
            <p class="mb1 mt1 text-truncate" v-html="subtitle"></p>
          </slot>

          
          
          <slot />

      </div>
    </w-flex>
  </w-card>
</template>

<script>
export default {
  name: 'z-dashboard-item',
  props: {
    useIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fal fa-user'
    },
    iconColor: String,
    useSlot: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: '/images/dashboard/item.png'
    },
    width: {
      type: Number,
      default: 65
    },
    height: {
      type: Number,
      default: 65
    },
    text: String,
    header: String,
    title: String,
    subtitle: String
  }
}
</script>

<style>
.z-dashboard-item:hover {
  /*background-color: #001f59;
  background-image: linear-gradient(to left, #001f59 , #000031);
  color: #fff;
  transition: background-color 1000ms linear;*/
}

.zditext {
  text-shadow: 2px 2px #b8b0b0d9;
  font-size: 30px;
}

</style>
